<script>
    import { menu } from "../../../stores";
    import { Link } from "svelte-routing";
    import Fa from "svelte-fa";
    import { faAddressBook } from "@fortawesome/free-solid-svg-icons";
  
    export let to = "";
  
    function getProps({ location, href, isPartiallyCurrent, isCurrent }) {
      const isActive = href === "/" ? isCurrent : isPartiallyCurrent || isCurrent;
  
      // The object returned here is spread on the anchor element's attributes
      if (isCurrent) {
        return { class: "menu-item active" };
      }
      return { class: "menu-item"};
    }
  </script>
  
  <li>
    <Link to="{to}" getProps="{getProps}" on:click={() => $menu = false}>
      {#if $$slots["icon"]}
        <div class="icon">
          <slot name="icon"></slot>
        </div>
      {/if}
      <slot />
    </Link>
  </li>

  <style>
    li {
      flex: 1;
    }

    :global(.menu-item) {
      box-sizing: border-box;
      /* height: 4rem; */
      line-height: 1.5;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 1rem 1.5rem;
      border-radius: 0.5rem;
      transition: border-radius 150ms cubic-bezier(0.3, 0.1, 0.25, 1.4);
    }

    :global(.menu-item),
    :global(.menu-item:active),
    :global(.menu-item:visited) {
      color: rgba(0, 0, 0, 0.8);
    }

    :global(.menu-item.active) {
      /* font-weight: bold; */
      /* border-bottom: 1px solid transparent; */
      /* color: rgba(0, 0, 0, 0.8); */
      background-color: #ebe6e2;
      border-radius: 20px;
    }

    :global(.menu-item:hover),
    :global(.menu-item:focus) {
      background-color: #ebe6e2;
      text-decoration: none;
      color: rgba(0, 0, 0, 0.8);
      border-radius: 20px;
      /* color: blue; */
    }

    .icon {
      margin-right: 1rem;
    }
  </style>

